import type { SelectOptionType } from '../../type';
import type { CheckboxGroupType } from '../types';

import { BlockStack, Box, Text } from '@shopify/polaris';
import { GCheckbox } from '~/presentation/ui';

interface CheckboxGroupProps {
  selected: string[];
  itemGroup: CheckboxGroupType;
  itemHovered?: string;
  hideTitle?: boolean;
  dependentDisabledValues?: Set<string>;
  onHover?: (value: string | undefined) => void;
  onChange: (value: string[]) => void;
}
export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  itemGroup,
  selected,
  hideTitle,
  dependentDisabledValues,
  onHover,
  onChange,
  itemHovered,
}) => {
  const getOptions = (options: SelectOptionType[]) => {
    return options.map((option) => ({
      ...option,
      selected: false,
    }));
  };

  const handleChangeSingleValue = (value: string) => {
    const updatedValues = selected.includes(value)
      ? selected.filter((item) => item !== value)
      : [...selected, value];

    onChange(updatedValues);
  };

  return (
    <BlockStack gap={hideTitle ? '0' : '300'}>
      {itemGroup.map((item, index) => (
        <Box key={index}>
          {!hideTitle && (
            <Text variant="headingMd" as="p">
              {item.title}
            </Text>
          )}
          <div className="ml-[-6px]">
            <GCheckbox
              multiple
              options={getOptions(item.options)}
              selected={selected}
              onChangeSingleValue={handleChangeSingleValue}
              onChange={() => {}}
              onHover={onHover}
              itemHovered={itemHovered}
              dependentDisabledValues={dependentDisabledValues}
            />
          </div>
        </Box>
      ))}
    </BlockStack>
  );
};
